import { ForbiddenError } from "./ForbiddenError.js";
class PreviewTokenExpiredError extends ForbiddenError {}
export { PreviewTokenExpiredError };
